import { render, staticRenderFns } from "./PageHero.vue?vue&type=template&id=186dec69&scoped=true"
import script from "./PageHero.vue?vue&type=script&lang=js"
export * from "./PageHero.vue?vue&type=script&lang=js"
import style0 from "./PageHero.vue?vue&type=style&index=0&id=186dec69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186dec69",
  null
  
)

export default component.exports